var map = {
	"./blogNews1.jpg": 84421,
	"./blogNews10.jpg": 45954,
	"./blogNews2.jpg": 20528,
	"./blogNews3.jpg": 34066,
	"./blogNews4.jpg": 13127,
	"./blogNews5.jpg": 76293,
	"./blogNews6.jpg": 57495,
	"./blogNews7.jpg": 68330,
	"./blogNews8.jpg": 84058,
	"./blogNews9.jpg": 1181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14862;